exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map[data-v-1e0ef166]{-webkit-box-shadow:rgba(0,0,0,.15) 0 0 15px;box-shadow:0 0 15px rgba(0,0,0,.15);width:100%;height:100%;min-height:100vh}@media screen and (max-height:500px){#map[data-v-1e0ef166]{min-height:500px}}", ""]);

// exports
